<template>
  <div class="container">
    <template v-if="errorInfo.statusCode >= 500">
      <template
        v-if="
          ['house_Link_has_expired', 'house_pk_Link_has_expired', 'house_pk_Link_has_deleted'].includes(errorInfo.message)
        "
      >
        <div>
          <img src="~/assets/expired.png" :class="isMobile ? 'png_isMobile' : 'png_PC'" />
        </div>
        <div v-if="isMobile">{{ $t(`error.${errorInfo.message}`) }}</div>
        <h1 v-else>{{ $t(`error.${errorInfo.message}`) }}</h1>
      </template>
      <template v-else>
        <div>
          <img src="~/assets/500.png" :class="isMobile ? 'png_isMobile' : 'png_PC'" />
        </div>
        <div v-if="isMobile">{{ errorInfo.message }}</div>
        <h1 v-else>{{ errorInfo.message }}</h1>
      </template>
    </template>
    <template v-else-if="errorInfo.statusCode === 404 || errorInfo.statusCode === 401">
      <div>
        <img src="~/assets/404.png" :class="isMobile ? 'png_isMobile' : 'png_PC'" />
      </div>
      <div v-if="isMobile">
        <router-link to="/">{{ $t('error.home_page') }}</router-link>
      </div>
      <h1 v-else>
        <router-link to="/">{{ $t('error.home_page') }}</router-link>
      </h1>
    </template>
    <template v-else>
      <div>
        <img src="~/assets/error.png" :class="isMobile ? 'png_isMobile' : 'png_PC'" />
      </div>
      <div v-if="isMobile">{{ $t('error.error_occurred') }}</div>
      <h1 v-else>{{ $t('error.error_occurred') }}</h1>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  computed: {
    errorInfo() {
      if (this.error && this.error.statusCode) {
        return this.error
      }
      const q = this.$route.query
      return {
        statusCode: Number(q.statusCode) || 500,
        message: q.message || '',
      }
    },
    isMobile() {
      return this.$store.state.layout == 'mobile' ? true : false
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  .png_isMobile {
    width: 4.56rem;
    height: 2.62rem;
    margin-bottom: 0.2rem;
  }
  .png_PC {
    margin-bottom: 20px;
  }
}
</style>